import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Spinner from "../../Components/Spinner";
import { useLanguage } from "../../Translations/LenguageContext";
import RandomStringGenerator from "../../Functions/GenerateRandomCode";

const RestoreBackupModal = ({ show, handleClose, selectedRecordId, fetchRecords, dbName }) => {
    const { t } = useLanguage()
    const user_id = sessionStorage.getItem("user_id")
    const [inputValue, setInputValue] = useState("");
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [loadingDel, setLoadingDel] = useState(false)
    const [mexActivate, setMexActivate] = useState("Restore database")

    const handleInputChange = (e) => {
        const value = e.target.value;
        setInputValue(value);

        if (value === mexActivate) {
            setIsButtonDisabled(false);
        } else {
            setIsButtonDisabled(true);
        }
    };

    const handleCloseModal = () => {
        handleClose()
        setTimeout(() => {
            setInputValue("")
        }, 100);
    }

    const restoreDb = (db_id) => {
        setLoadingDel(true)
        fetch("https://backend.erioon.com/restore_db_from_deleted", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                user_id,
                db_id
            })
        })
            .then(response => response.json())
            .then(data => {
                if (data.message == "OK") {
                    handleCloseModal()
                    fetchRecords()
                }
                setLoadingDel(false)
            })
            .catch(error => {
                setLoadingDel(false)
            });
    }


    return (
        <Modal show={show} onHide={handleCloseModal} className="modal_delete">
            <div className="share_main_cont_modal">

                <p className="share_label">{t.cloud.restore_file}</p>
                <p className="warning_delete_message">
                    This action will restore the selected database: <strong>{dbName}</strong>
                </p>
                <div className="delete_action_cont">
                    <p className="type_phrase_delete">{t.delete_modal.confirm_del_mex} <strong>{mexActivate}</strong></p>
                    <input
                        className="delete_input"
                        placeholder={` ${mexActivate}`}
                        value={inputValue}
                        onChange={handleInputChange}
                    />
                </div>
            </div>
                <div className="modal_footer">
                    <div className="footer_btn_cont">
                        <button
                            className={`activate_btn ${isButtonDisabled ? "" : "activate_btn_active"}`}
                            onClick={() => restoreDb(selectedRecordId)}
                            disabled={isButtonDisabled}
                        >
                            {loadingDel ? (
                                <Spinner loading={loadingDel} />
                            ) : (
                                <>Restore</>
                            )}
                        </button>

                        <button className="cancel_btn" onClick={handleCloseModal}>{t.cancel}</button>
                    </div>
                </div>
        </Modal>
    )
};

export default RestoreBackupModal;
